<template>
  <!-- 红包管理-福利红包管理 -->
  <div class="pwd_redenvelope-box">
    <!-- header头部 -->
    <header>
      <!-- <el-button type="primary" class="add-btn" @click="addVisible = true"
        >添加红包</el-button
      > -->
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="红包开关：" style="margin-right:30px">
          <el-switch
            v-model="openMark"
            :active-value="1"
            :inactive-value="0"
            active-text="打开"
            inactive-text="关闭"
            @change="handleRedPacketEnable"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="口令开关：">
          <el-switch
            v-model="openPwdMark"
            :active-value="1"
            :inactive-value="0"
            active-text="打开"
            inactive-text="关闭"
            @change="handleRedPacketPwd"
          >
          </el-switch>
        </el-form-item>
      </el-form>
    </header>

    <!-- body内容主体 -->
    <div class="body-box">
      <!-- 表格 -->
      <!-- <el-table v-loading="loading" :data="dataList">
        <el-table-column prop="type" label="红包类型" align="center">
          <template slot-scope="{ row }">
            <span v-if="parseInt(row.type) === 1">一次性失效随机红包</span>
            <span v-if="parseInt(row.type) === 2">多次随机红包</span>
            <span v-if="parseInt(row.type) === 3">多次固定红包</span>
						<span v-if="parseInt(row.type) === 4">当日福利红包</span>
						<span v-if="parseInt(row.type) === 5">CDK充值红包</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="use_num"
          label="使用次数"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="failure_time"
          label="失效时间"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="min_price"
          label="金额最低值"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="max_price"
          label="金额最高值"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="total_price"
          label="红包总额"
          align="center"
        ></el-table-column>
        <el-table-column prop="price_type" label="红包方式" align="center">
          <template slot-scope="{ row }">
            <span v-if="parseInt(row.price_type) === 1">随机金额</span>
            <span v-if="parseInt(row.price_type) === 2">固定总额</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="show_text"
          label="多次固定红包"
          align="center"
        ></el-table-column>
      </el-table> -->

      <!-- 底部分页条 -->
      <!-- <el-pagination
				background
				:page-size="dataMeta.per_page || 15"
				:total="dataMeta.total || 0"
				:current-page="page"
				@current-change="handlePageChange"
				v-if="dataMeta && dataMeta.total > dataMeta.per_page"
			></el-pagination> -->
    </div>

    <!-- 弹窗-->
    <!-- 添加红包 -->
    <el-dialog
      title="添加福利详情"
      :visible.sync="addVisible"
      width="350px"
      center
    >
      <el-form
        :model="addFormData"
        label-width="90px"
        :rules="addrules"
        ref="form"
        size="small"
      >
        <el-form-item prop="type" label="红包类型">
          <el-select v-model="addFormData.type" :hide-required-asterisk="true">
            <el-option label="一次性失效随机红包" :value="1"></el-option>
            <el-option label="多次随机红包" :value="2"></el-option>
            <el-option label="多次固定红包" :value="3"></el-option>
            <el-option label="当日福利红包" :value="4"></el-option>
            <el-option label="CDK充值红包" :value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="addFormData.type === 4 || addFormData.type === 5"
          prop="recharge_limit"
          label="充值金额"
        >
          <el-input
            v-model="addFormData.recharge_limit"
            placeholder="请设置金额"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="addFormData.type != 4"
          prop="failure_time"
          label="失效时间"
        >
          <el-date-picker
            v-model="addFormData.failure_time"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="use_num" label="使用次数">
          <el-input
            v-model="addFormData.use_num"
            placeholder="使用次数"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password_val" label="福利值">
          <el-input
            v-model="addFormData.password_val"
            placeholder="固定福利红包时福利值必填"
          ></el-input>
        </el-form-item>
        <el-form-item prop="price_type" label="红包方式">
          <el-select v-model="addFormData.price_type">
            <el-option label="随机金额" :value="1"></el-option>
            <el-option label="固定总额" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="min_price" label="金额最低值">
          <el-input-number
            v-model="addFormData.min_price"
            :min="0.01"
            label="金额最低值"
          ></el-input-number>
        </el-form-item>
        <el-form-item prop="max_price" label="金额最高值">
          <el-input-number
            v-model="addFormData.max_price"
            :min="1"
            label="金额最高值"
          ></el-input-number>
        </el-form-item>
        <el-form-item prop="total_price" label="红包总额">
          <el-input-number
            v-model="addFormData.total_price"
            :min="1"
            label="红包总额"
          ></el-input-number>
        </el-form-item>
        <el-form-item prop="show_text" label="展示文字">
          <el-input v-model="addFormData.show_text"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="addSubmit"
          :loading="buttonLoading"
          style="margin-left: 50px"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { delData, getData, getApiData, patchData, patchApiData, postData, postApiData } from '../../http'

export default {
  name: 'pwd_redenvelope',
  data() {
    return {
      buttonLoading: false,//按钮加载动画
      loading: false,//加载动画
      addVisible: false,//添加红包模态框标志
      openMark: 0,//开关标志,0是关闭，1是打开
      openPwdMark:0,//口令开关标志,0是关闭，1是打开
      query_pwd: {//查询表格的查询信息,默认第一页
        page: 1
      },
      addFormData: {//添加红包表单信息
        failure_time: new Date(),//失效时间
        use_num: undefined,//使用次数
        min_price: undefined,
        max_price: undefined,
        type: undefined,
        recharge_limit: 0,
        show_text: undefined,
        password_val: '',
        price_type: undefined,
        total_price: undefined
      },
      dataList: undefined,//表格数据
      page: 1,//底部页数，默认为1
      dataMeta: undefined,//底部跳转页面条
      addrules: {//添加表单校验规则
        // failure_time: [{ required: true, message: '请输入失效时间' }],
        use_num: [{ required: true, message: '请输入最多使用次数' }],
        price_type: [{ required: true, message: '请选择红包方式' }],
        show_text: [{ required: true, message: '请输入展示文字' }]
      },
    }
  },
  created() {
    // this.getData();//获取表格数据
    this.getPasswordPacketConfig();//获取红包按钮状态
    this.getPasswordPacketPwdConfig();//获取红包口令按钮状态
  },
  methods: {
    getData() {
      //拿去表格数据信息
      this.loading = true
      let params = {
        page: this.query_pwd.page
      }
      getApiData('password_packet', params)
        .then(res => {
          this.dataList = res.data
          //设置底部导航条数据
          this.dataMeta = {
            current_page: res.current_page,
            per_page: res.per_page,
            total: res.total
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    addSubmit() {
      //确定添加福利红包
      //进行表单验证
      this.$refs['form'].validate(valid => {
        if (valid) {
          if (this.addFormData.type != 4 && !this.addFormData.failure_time) {
            this.$message.error('失效时间不能为空')
            return
          }
          this.buttonLoading = true
          let params = this.addFormData
          postApiData('password_packet', params)
            .then(res => {
              this.buttonLoading = false
              this.addVisible = false
              this.$message.success('添加成功')
              this.getData()//刷新列表
            })
            .finally(() => {
              this.buttonLoading = false
            })
        }
      })
    },
    getPasswordPacketConfig() {
      //获取关闭/打开红包按钮状态
      getApiData('welfare_red_envelopes')
        .then(res => {
          if (res) {
            res.data ? this.openMark = 1 : this.openMark = 0
          }
        })
    },
    handleRedPacketEnable() {
      //关闭/打开红包按钮
      let params = { "black": this.openMark ? 1 : 0 }
      patchApiData('welfare_red_envelopes', params)
        .then(res => {
          this.$message.success('操作成功！')
        }).catch(err => {
          //关闭/打开红包按钮失败，还原标志
          this.openMark = !this.openMark
        })
    },
    getPasswordPacketPwdConfig() {
      //获取关闭/打开口令按钮状态
      getApiData('unpack_limit/5')
        .then(res => {
          if (res) {
            res.enable ? this.openPwdMark = 1 : this.openPwdMark = 0
          }
        })
    },
    handleRedPacketPwd(val){
      //关闭/打开口令按钮
      let params = {
        type:5, 
        enable: val,
        content:val
       }
      patchApiData(`unpack_limit`, params)
        .then(res => {
          this.$message.success('操作成功！')
        }).catch(err => {
          //关闭/打开红包按钮失败，还原标志
          this.openPwdMark = !this.openPwdMark
        })
    },
    pathToCdkey(id) {
      //福利列表
      let routeData = this.$router.resolve({ path: `/password_packets/${id}` })
      window.open(routeData.href, '_blank')
      // this.$router.push({
      //   name:"password_packets",
      //   params:{
      //     'packet_id':id
      //   }
      // })
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query_pwd.page = page
      this.getData();
    },
  },
}
</script>
<style lang="less" scoped>
.pwd_redenvelope-box {
  header {
    margin-bottom: 10px;
    .add-btn {
      margin-right: 30px;
    }
  }
  .body-box {
    //底部分页导航条
    .underBar {
      margin-top: 20px;
    }
  }
}
</style>